import axios from 'axios';
import * as types from '../mutation-types';
import config from '@/config';
import { loadDataForSnapshot } from '@/utils/loading';


const state = {
  notifications: {},
};

const mutations = {
  [types.SET_NOTIFICATIONS]: (state, data) => {
    state.notifications = data;
  },
  [types.UPDATE_NOTIFICATION]: (state, payload) => {
    state.notifications[payload.notification.id] = { ...payload.data };
  },
  [types.SET_NOTIFICATION_ENABLED]: (state, payload) => {
    state.notifications[payload.notification.id].enabled = payload.enabled;
  },
};

const getters = {
  getNotifications: state => Object.values(state.notifications),
  getNotificationsByServiceId: (state, getters) => serviceId => getters.getNotifications.filter(
    notification => notification.service === serviceId,
  ),
  getEnabledNotifications: (state, getters) => getters.getNotifications.filter(
    n => n.subscribers.length > 0 && n.subscribers[0].enabled === true,
  ),
};

const actions = {
  async loadNotifications({ commit, rootState }) {
    return loadDataForSnapshot(
      commit, rootState, types.SET_NOTIFICATIONS, config.ICOOL.API.USER_NOTIFICATIONS_PATH,
    );
  },
  async updateNotification({ commit, rootState }, notification) {
    const url = new URL(
      config.ICOOL.API.USER_NOTIFICATION_PATH(
        rootState.snapshot.currentSnapshot.id, notification.id,
      ),
      config.ICOOL.BACKEND_HOST,
    ).href;
    try {
      const response = await axios.get(url);
      commit(types.UPDATE_NOTIFICATION, { notification, data: response.data });
    } catch (err) {
      console.log(error);
    }
  },
  setNotificationSubscription({ commit, rootState }, { notification, subscription }) {
    commit(
      types.UPDATE_NOTIFICATION,
      { notification, data: { ...notification, subscribers: [subscription] } },
    );
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
